module.exports = {
  context: {
    input: {
      name: 'email',
      type: 'email',
      required: true,
      label: 'Input Text Field',
      placeholder: 'Enter your email'
    },
    button: {
      text: 'Submit',
      title: 'Submit Email Signup',
      class: 'secondary'
    },
    csrfTokenName: 'token',
    csrfToken: 'abcdefg'
  }
}
